export default "__VITE_ASSET__C4Lu4n9P__"